import React from 'react'
import UserSidebar from './Components/UserSidebar'
const Sold = () => {
  return (
    <div>
       <div className="container user-dashboard-page">
            <div className=" user-sidebar">
                <UserSidebar />

            </div>
            <div className="user-main">
            
Sold items will show here
            </div>
        </div>
    </div>
  )
}

export default Sold
